import { tracking } from '@iwoca/frontend-tracking-library';
import { BaseEvent, Event } from '@iwoca/frontend-tracking-library/lib/ampli';

type TOptions = {
  includePageData: boolean;
};

export function useAmplitude() {
  const trackEvent = (
    event: string,
    payload?: BaseEvent['event_properties'],
    options: TOptions = { includePageData: true },
  ) => {
    if (options.includePageData) {
      payload = {
        'Page name': document.title,
        URL: window.location.pathname,
        ...(payload || {}),
      };
    }

    // Ensure that 'event' and 'locale' are passed correctly
    const eventPayload: BaseEvent = {
      event_type: event,
      event_properties: payload || {},
    };

    // Temporarily track the event using Amplitude's track method as we are still using hardcoded events
    tracking.ampli.track(
      event as unknown as Event,
      eventPayload, // Pass the entire payload
    );
  };

  return {
    trackEvent,
  };
}
